export enum EAccountIsActive {
	active = 'active',
	unactive = 'unactive',
}

export const ACCOUNT_IS_ACTIVE_LABEL_MAP: Record<EAccountIsActive, string> = {
	[EAccountIsActive.active]: `account_is_active.${EAccountIsActive.active}`,
	[EAccountIsActive.unactive]: `account_is_active.${EAccountIsActive.unactive}`
}